import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "Flag.svg",
  "use": "Flag.svg-usage",
  "viewBox": "0 0 64 64",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 64 64\" id=\"Flag.svg\"><path d=\"M54.0208,40.5839c-10.6667,1.7257-21.3334-2.5185-32-.7928a1.6212,1.6212,0,0,1-2-1.6274,2.5375,2.5375,0,0,1,2-2.42V15.5053a1.6211,1.6211,0,0,1-2-1.6273,2.5376,2.5376,0,0,1,2-2.42c10.6667-1.7257,21.3334,2.5186,32,.7929a1.6212,1.6212,0,0,1,2,1.6274V38.1637A2.5376,2.5376,0,0,1,54.0208,40.5839Zm-40,15.4369v-44a2,2,0,1,1,4,0v44a2,2,0,1,1-4,0Z\" fill-rule=\"evenodd\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol